import { action } from 'satcheljs';
import { TableView } from 'owa-mail-list-store';

/**
 * Action to move shared folder conversations
 * @param rowKeys - rowkeys to move
 * @param destinationFolderId - folderId of the destination folder
 * @param originalTableView - TableView of the source folder
 * @param sourceFolderId - source folderId
 */
const moveSharedFolderConversations = action(
    'MOVE_SHARED_FOLDER_CONVERSATIONS',
    (rowKeys: string[], destinationFolderId: string, originalTableView: TableView) => {
        return {
            rowKeys,
            destinationFolderId,
            originalTableView,
        };
    }
);

export default moveSharedFolderConversations;
